// import log from '@scrtracker/logging';
import permissionsList from '@hogwarts/permissions';
import { usePermission } from './usePermission';

export const useDiagnostics = (): boolean => {
  return usePermission(permissionsList.SUPPORT_ADMINISTRATOR);
};
